// src/pages/items/ItemForm.js
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import itemService from '../../services/itemService';
import eventService from '../../services/eventService';
import itemTypeService from '../../services/itemTypeService';
import { find, isEmpty, map, toUpper } from 'lodash';
import roleService from '../../services/roleService';
import { toast } from 'react-toastify';

const ItemForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [roles, setRoles] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);
  const [initialValues, setInitialValues] = useState({
    item_name: '',
    station_type: 'ROUTE',
    event_id : parseInt(localStorage?.getItem('event_id')),
    // item_type_id: '',
    // barcode: '',
  });

  useEffect(() => {
    const fetchItem = async () => {
      if (id) {
        const response = await itemService.getItem(id);
        setInitialValues({
          ...response.data,
        });
      }
    };
    fetchItem();
  }, [id]);

  const fetchEvents = async () => {
    const response = await eventService.getEvents();
    setEvents(response.data);
  };

  const fetchItemTypes = async () => {
    const response = await itemTypeService.getItemTypes();
    setItemTypes(response.data);
  };

  const fetchRoles = async () => {
    const response = await roleService.getRoles();
    setRoles(response.data);
  };

  useEffect(() => {
    // fetchEvents();
    // fetchItemTypes();
    // fetchRoles();
  }, []);

  const validationSchema = Yup.object().shape({
    item_name: Yup.string().required('Product Name is required'),
    station_type: Yup.string().required('Staion type is required'),
    // item_type_id: Yup.string().required('Product Type is required'),
    // event_id: Yup.string().required('Event ID is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (id) {
        await itemService.updateItem(id, {
          ...values,
          // event_id: parseInt(values?.event_id),
          // item_type_id: parseInt(values?.item_type_id),
        });
      } else {
        await itemService.createItem({
          ...values,
          // event_id: parseInt(values?.event_id),
          // item_type_id: parseInt(values?.item_type_id),
        });
      }
      navigate('/items');
    } catch (error) {
      toast?.error(error?.response?.data?.message);
      console.error(error); // Handle error appropriately
    } finally {
      setSubmitting(false);
    }
  };

  const labelStyle = {
    color: '#000',
    fontSize: '0.87rem',
    marginTop: 8,
  };

  return (
    <LayoutContainer>
      <AdminHeader
        title={id ? 'EDIT PRODUCT' : 'ADD PRODUCT'}
        backTo='/items'
      />
      <Box
        className='page-content-wrapper scrollable'
        p={3}
        sx={{ display: 'flex', backgroundColor: '#efefef' }}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            setFieldValue,
            touched,
          }) => (
            <form onSubmit={handleSubmit} style={{ width: '50%' }}>
              <Card>
                <CardContent>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}
                  >
                    <Typography variant='body2' sx={{ fontWeight: 600 }}>
                      PRODUCT<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      name='item_name'
                      fullWidth
                      value={values.item_name}
                      onChange={(e) => {
                        const capitalizedValue = toUpper(e.target.value); // Capitalize first letter
                        handleChange({
                          target: {
                            name: 'item_name',
                            value: capitalizedValue,
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      sx={{
                        backgroundColor: '#f5f5f5',
                        borderRadius: 1,
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor:
                              touched.item_name && errors.item_name
                                ? '#d32f2f'
                                : '#ccc',
                          },
                        },
                      }}
                    />
                    {touched.item_name && errors.item_name && (
                      <FormHelperText style={{ color: '#D32F2F' }}>
                        {errors.item_name}
                      </FormHelperText>
                    )}
                  </Box>
                  <Typography variant='body2' sx={{ fontWeight: 600, mt: 1 }}>
                    TYPE <span style={{ color: 'red' }}>*</span>
                  </Typography>
                  <RadioGroup
                    name='station_type'
                    // fullWidth
                    value={values.station_type || ''}
                    onChange={(e) => {
                      const capitalizedValue = toUpper(e.target.value); // Capitalize first letter
                      handleChange({
                        target: {
                          name: 'station_type',
                          value: capitalizedValue,
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    row
                    sx={{ gap: 3 }}
                  >
                    <FormControlLabel
                      value='JUNCTION'
                      control={<Radio />}
                      label='JUNCTION'
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontSize: '0.675rem',
                          fontWeight: 500,
                          color: '#333',
                        },
                      }}
                    />
                    <FormControlLabel
                      value='ROUTE'
                      control={<Radio />}
                      label='ROUTE'
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontSize: '0.675rem',
                          fontWeight: 500,
                          color: '#333',
                        },
                      }}
                    />
                  </RadioGroup>
                  {touched.station_type && errors.station_type && (
                    <FormHelperText error>{errors.station_type}</FormHelperText>
                  )}

                  {/* <TextField
                placeholder='Item Type ID'
                name='item_type_id'
                fullWidth
                margin='normal'
                value={values.item_type_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.item_type_id && Boolean(errors.item_type_id)}
                helperText={touched.item_type_id && errors.item_type_id}
              /> */}
                  {/* <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.6,
                      mt: 1,
                    }}
                  >
                    <Typography variant='body2' sx={{ fontWeight: 600 }}>
                      Product Type <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Select
                      name='item_type_id'
                      value={values.item_type_id}
                      fullWidth
                      onChange={(e) => {
                        setFieldValue('item_type_id', e?.target?.value);
                      }}
                      onBlur={handleBlur}
                      sx={{
                        backgroundColor: '#f5f5f5',
                        borderRadius: 1,
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor:
                              touched.item_type_id && errors.item_type_id
                                ? '#d32f2f'
                                : '#ccc',
                          },
                        },
                      }}
                    >
                      {!isEmpty(itemTypes) ? (
                        map(itemTypes, (option) => (
                          <MenuItem key={option?.id} value={option?.id}>
                            {option?.type}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem>No data found</MenuItem>
                      )}
                    </Select>
                    {touched.item_type_id && errors.item_type_id && (
                      <FormHelperText style={{ color: '#D32F2F' }}>
                        {errors.item_type_id}
                      </FormHelperText>
                    )}
                  </Box> */}
                  {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Event</div>
                <Select
                  name='event_id'
                  value={values.event_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(events) ? (
                    map(events, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.event_id && errors.event_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.event_id}
                  </FormHelperText>
                )}
              </Box> */}
                  {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Roles</div>
                <Select
                  name='role_name'
                  value={values.role_name}
                  fullWidth
                  onChange={(e) => {
                    setFieldValue('role_name', e?.target?.value);
                  }}
                  onBlur={handleBlur}
                >
                  {!isEmpty(roles) ? (
                    map(roles, (option) => (
                      <MenuItem key={option?.id} value={option?.name}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.role_name && errors.role_name && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.role_name}
                  </FormHelperText>
                )}
              </Box> */}

                  {/* <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.6,
                      mt: 1,
                    }}
                  >
                    <Typography variant='body2' sx={{ fontWeight: 600 }}>
                      Roles
                    </Typography>
                    <TextField
                      select
                      name='product_roles'
                      fullWidth
                      value={values?.product_roles || []}
                      onChange={(e) => {
                        const {
                          target: { value },
                        } = e;
                        setFieldValue(
                          'product_roles',
                          typeof value === 'string' ? value.split(',') : value
                        );
                        handleChange(e);
                      }}
                      sx={{
                        backgroundColor: '#f5f5f5',
                        borderRadius: 1,
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor:
                              touched.product_roles && errors.product_roles
                                ? '#d32f2f'
                                : '#ccc',
                          },
                        },
                      }}
                      onBlur={handleBlur}
                      error={
                        touched.product_roles && Boolean(errors.product_roles)
                      }
                      helperText={touched.product_roles && errors.product_roles}
                      SelectProps={{
                        multiple: true,
                      }}
                    >
                      {roles?.map((role) => (
                        <MenuItem key={role.name} value={role.name}>
                          {role.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box> */}

                  <Box
                    sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}
                  >
                    <Button
                      type='submit'
                      variant='contained'
                      sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                    >
                      {id ? 'UPDATE' : 'CREATE'}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </LayoutContainer>
  );
};

export default ItemForm;
